const isClientSide = !!(typeof window !== 'undefined');

export { isClientSide };
